import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'Contact Zeller For Setup',
  description:
    'If you wish to utilise this feature, please get in touch with {linkSupport}, who will assist you with getting started.',
  linkSupport: 'Zeller Support',
  linkSupportHref: 'https://www.myzeller.com/support',
})
